import { useState, useEffect, useCallback } from "react";

import api from "../../services/api";

// O que a empresa logada contratou. Serve para esconder do menu o que ela
// não pode usar — sem isso a pessoa só descobre ao clicar e tomar um 403.
const useModules = () => {
	const [modules, setModules] = useState([]);
	const [assinatura, setAssinatura] = useState(null);
	const [carregando, setCarregando] = useState(true);

	const carregar = useCallback(async () => {
		try {
			const { data } = await api.get("/subscriptions/mine");
			setModules((data.modules || []).map((m) => m.key));
			setAssinatura(data);
		} catch (err) {
			// Falha aqui não pode esconder o sistema inteiro: sem resposta,
			// libera o menu e deixa o backend barrar quem não tiver acesso.
			setModules(null);
		}
		setCarregando(false);
	}, []);

	useEffect(() => {
		carregar();
	}, [carregar]);

	// modules === null significa "não consegui saber" — não esconde nada.
	const temModulo = useCallback(
		(chave) => modules === null || modules.includes(chave),
		[modules]
	);

	return { modules, assinatura, temModulo, carregando, recarregar: carregar };
};

export default useModules;
